import { parametersTypes } from "../../../../classes/consts";
import { handleInput } from "../../../../classes/functions";

export default function Inputs({infos}){    
    return (
        <div className="divGroup">
            <div className="formDiv">
                <label>Nome</label>&nbsp;<label className="required">*</label><br />
                <input type="text" name="nome" placeholder="Nome" value={infos.state.nome} onChange={(event) => handleInput(infos.setState, event)} />
            </div>
            <div className="formDiv">
                <label>Descrição</label>&nbsp;<label className="required">*</label><br />
                <input type="text" name="descricao" placeholder="Descrição" value={infos.state.descricao} onChange={(event) => handleInput(infos.setState, event)} />
            </div>
            <div className="formDiv">
                <label>Tipo</label>&nbsp;<label className="required">*</label><br />
                <select value={infos.state.tipo} name="tipo" onChange={(event) => handleInput(infos.setState, event, "number")}>
                    <option>Selecione</option>
                    {parametersTypes.map((type, index) => {
                        return (
                            <option value={type.value} key={index}>{type.label}</option>
                        )
                    })}
                </select>
            </div>
        </div>
    )
}